import React, { useEffect, useState } from 'react';

import {
  ICustomerItem,
  ICustomerObject,
} from 'pages/Shared/DealerCustomers/Models';
import { toastSlice } from 'slices';
import { IDealerInfo } from 'slices/auth';
import { useAppDispatch } from 'store/hooks';
import { useTranslation } from 'react-i18next';
import { Spinner2 } from 'components';
import {
  useGetOnlyOwnCustomerListQuery,
  useGetRegistrationDbCustomerInfoQuery,
} from 'thunks/RTKQuery/dealerCustomer';
import { IDealerTicket } from 'thunks/RTKQuery/dealer';
import { convertDbCustomerToNewCustomer } from './Utility';
import { CustomerDetailModelComponent } from './component';

interface ICustomerDetailModel {
  show: boolean;
  dealerTicketRow: IDealerTicket;
  rootDealer?: IDealerInfo;
  loggedInDealer?: IDealerInfo;
  assignTicketToCustomer: (
    dealerTicketId: number,
    dealerCustomerId: number,
    savedCustomerObj?: ICustomerItem
  ) => void;
  onClose: () => any;
}

export const DealerCustomersDetailModal = ({
  show,
  dealerTicketRow,
  rootDealer,
  loggedInDealer,
  assignTicketToCustomer,
  onClose,
}: ICustomerDetailModel) => {
  const dispatch = useAppDispatch();
  const [customerSelected, setCustomerSelected] = useState<ICustomerItem>();
  const [errorString, setErrorString] = useState('');
  const [viewOnly, setViewOnly] = useState(false);
  const { t } = useTranslation();
  const [
    registrationDbCustomerData,
    setRegistrationDbCustomerData,
  ] = React.useState<ICustomerObject | null>(null);

  const { data: customerData = [], isLoading } = useGetOnlyOwnCustomerListQuery(
    dealerTicketRow?.dealerId || '0',
    dealerTicketRow?.dealerId === undefined ? { skip: true } : {}
  );

  // Fetch registration data for the selected ticket
  const {
    data: registrationData,
    isLoading: registrationLoading,
  } = useGetRegistrationDbCustomerInfoQuery(dealerTicketRow.ticketId, {
    skip: !dealerTicketRow.ticketId,
  });

  useEffect(() => {
    if (loggedInDealer) {
      setViewOnly(loggedInDealer.dealerId !== rootDealer?.dealerId);
    }
  }, [loggedInDealer, rootDealer]);

  useEffect(() => {
    if (!registrationData || !registrationData?.productid) return;
    setRegistrationDbCustomerData(
      convertDbCustomerToNewCustomer(registrationData, rootDealer)
    );
  }, [registrationData]);

  useEffect(() => {
    if (dealerTicketRow.ticketId && customerSelected?.customerInfo?.id) {
      assignTicketToCustomer(
        dealerTicketRow.dealerTicketId,
        +customerSelected?.customerInfo?.id,
        customerSelected
      );
      setCustomerSelected(undefined);
      onClose();
    }
  }, [
    customerSelected,
    dealerTicketRow.ticketId,
    assignTicketToCustomer,
    onClose,
  ]);
  useEffect(() => {
    if (errorString !== '') {
      dispatch(
        toastSlice.actions.show({
          title: t('customerManagement.create'),
          message: errorString,
        })
      );
    }
    setErrorString('');
  }, [errorString]);
  return (
    <>
      <Spinner2 show={registrationLoading} />
      <CustomerDetailModelComponent
        show={show}
        viewOnly={viewOnly}
        rootDealer={rootDealer}
        loggedInDealer={loggedInDealer}
        setCustomerSelected={setCustomerSelected}
        onClose={onClose}
        registrationDbData={registrationDbCustomerData as ICustomerObject}
        errorString={errorString}
        setErrorString={setErrorString}
        customerData={customerData as ICustomerItem[]}
        assignedCustomerId={
          dealerTicketRow &&
          dealerTicketRow.customer &&
          dealerTicketRow.customer.id
            ? dealerTicketRow.customer.id
            : 0
        }
        isLoading={isLoading}
        dealerId={dealerTicketRow?.dealerId || ''}
        dealerName={dealerTicketRow?.dealerName || ''}
      />
    </>
  );
};

DealerCustomersDetailModal.defaultProps = {
  rootDealer: undefined,
  loggedInDealer: undefined,
};
